// Class: lime.math.CairoMatrix3

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;

// Constructor

var CairoMatrix3 = function(a,b,c,d,tx,ty) {
	if(ty == null) {
		ty = 0;
	}
	if(tx == null) {
		tx = 0;
	}
	if(d == null) {
		d = 1;
	}
	if(c == null) {
		c = 0;
	}
	if(b == null) {
		b = 0;
	}
	if(a == null) {
		a = 1;
	}
	this.a = a;
	this.b = b;
	this.c = c;
	this.d = d;
	this.tx = tx;
	this.ty = ty;
}

// Meta

CairoMatrix3.__name__ = "lime.math.CairoMatrix3";
CairoMatrix3.__isInterface__ = false;
CairoMatrix3.prototype = {
	
};
CairoMatrix3.prototype.__class__ = CairoMatrix3.prototype.constructor = $hxClasses["lime.math.CairoMatrix3"] = CairoMatrix3;

// Init



// Statics




// Export

exports.default = CairoMatrix3;